import axios from 'axios';
import Vue from 'vue'

export default {

    setIsCampaignWithGift (isWithGift, uniqueGift, page, pageSize, start, end, campaignId) {
        return axios.get('/api/gift/update/campaign', { params: { isWithGift:isWithGift, uniqueGift:uniqueGift, page: page, pageSize: pageSize, start:start, end:end, campaignId:campaignId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getAllGift (page, pageSize, start, end, campaignId) {
        return axios.get('/api/gift/list', { params: { page: page, pageSize: pageSize, start:start, end:end, campaignId:campaignId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getAllGiftWinner (page, pageSize, start, end, campaignId) {
        return axios.get('/api/gift/list/giftWinner', { params: { page: page, pageSize: pageSize, start:start, end:end, campaignId:campaignId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    removeGiftImage(giftId) {
        return axios.post('/api/image/remove/file/gift/'+giftId)
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    addGift (gift ,page, pageSize) {
        return axios.post('/api/gift/add' ,gift, { params: { page: page, pageSize: pageSize} } ,{ headers: {
                'Content-Type': 'multipart/form-data'
              }}
        )
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
}
